import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface ContentProps {
  children: ReactNode;
  className?: string;
}

export const Content = ({ children, className }: ContentProps) => (
  <div
    className={classNames(
      anchorClassNames("main__content"),
      "mx-auto h-full max-w-5xl",
      className,
    )}
  >
    {children}
  </div>
);
